module.exports = __webpack_public_path__ + "static/8-0bd3e74c1372089d02b81144f932abda.jpg";